const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class EmptyCart extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 2.1,
              spacing: 5,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('empty-cart')) {
  customElements.define('empty-cart', EmptyCart)
}
